import vuex from "src/vuex";
import * as Cookies from "js-cookie";
import axios from "axios";
import { reloadOnce } from "src/util/chunkReload";

export default async (to, from, next) => {
  axios.get(`${document.location.protocol + "//" + process.env.VUE_APP_API_HOST}/api/verify_app_version/${process.env.VUE_APP_LAST_VERSION}`, {})
    .then((request) => {
      if(request.data.need_refresh_app){
        reloadOnce(window.location.href);
      }
    })
  next();
};


